import { $api } from 'modules/global';

export const getThemedTestQuiz = async (testId: string | string[] | undefined) => {
  const { data } = await $api.get('/themed-order', {
    params: { test_id: testId }
  });

  return data;
};
